import { MakeCall } from './createMakeCall';
import { Listing } from '../lib/types/Listing';

interface Query {
  expand?: string;
}

const getSimilarListings =
  (makeCall: MakeCall) =>
  ({ listingId, expand }: Query & { listingId: string }) =>
    makeCall<Listing[]>('GET', `/api/v2/unit-type/${listingId}/similar`, {
      query: {
        expand,
      },
    });

export { getSimilarListings };
